import type { TenantDatabase } from './tenant-db';

/**
 * De inspecteur heeft de melding gezien. De regel blijft bewaard (wat er
 * vervangen of geweigerd is gaat nooit stil verloren), maar telt niet meer mee
 * in de sync-indicator.
 */
export async function acknowledgeConflicts(
    db: TenantDatabase,
    ids: readonly string[],
): Promise<void> {
    await db.conflicts
        .where('id')
        .anyOf([...ids])
        .modify({ acknowledged: 1 });
}
